import {
  HeroConversation,
  useGetReverseGeolocation,
} from '@vs-online-only-app/state';

export const useConversationShopperLocation = (
  conversation?: HeroConversation
) => {
  const { data: locationResponse } = useGetReverseGeolocation(
    conversation
      ? {
          lng: conversation.conversationStarter.location[0],
          lat: conversation.conversationStarter.location[1],
        }
      : undefined
  );

  const formattedAddress = locationResponse?.results.find(
    ({ types }) => types[0] === 'locality' && types[1] === 'political'
  )?.formatted_address;

  return { formattedAddress };
};
